import styled from '@emotion/styled'

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 48px 20px 0;
`

export const QuizIcon = styled.img`
  width: 32px;
  height: 32px;
  object-fit: contain;
`

export const HeaderTitle = styled.span`
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
`

export const RewardRow = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`

export const RewardCount = styled.span`
  font-size: 22px;
  font-weight: 600;
  color: #ffcd30;
`

export const EnergyIcon = styled.img`
  width: 18px;
  height: 18px;
  object-fit: contain;
`
